import r from "./td-longtail-vue-components98.js";
const s = {};
var e = function() {
  var t = this, n = t._self._c;
  return n("svg", { attrs: { viewBox: "0 0 137 137", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [n("path", { attrs: { d: "M68.5.5a68 68 0 1 0 0 136 68 68 0 0 0 0-136m0 19.43c9.88 0 19.07 2.98 26.75 8.07L28 95.25a48.3 48.3 0 0 1-8.07-26.75A48.63 48.63 0 0 1 68.5 19.93m0 97.14A48.3 48.3 0 0 1 41.73 109L109 41.73a48.3 48.3 0 0 1 8.08 26.77 48.63 48.63 0 0 1-48.57 48.57", fill: "#B2B2B2" } })]);
}, o = [], a = /* @__PURE__ */ r(
  s,
  e,
  o,
  !1,
  null,
  null
);
const l = a.exports;
export {
  l as default
};
